/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Print_InvoiceInputs */

const vi_pos_print_invoice = /** @type {(inputs: Pos_Print_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In hóa đơn thanh toán`)
};

/**

* @param {Pos_Print_InvoiceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_print_invoice = /** @type {((inputs?: Pos_Print_InvoiceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Print_InvoiceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_print_invoice(inputs)
});